import { collection, deleteDoc, doc, getDoc, getDocs, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const getAll = async () => {
  const snapshot = await getDocs(collection(db, 'accounts'));
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

const get = async (id) => {
  const docSnap = await getDoc(doc(db, 'accounts', id));
  return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : {};
};

const remove = async (id) => {
  await deleteDoc(doc(db, 'accounts', id));
};

const add = async (data) => {
  await setDoc(doc(db, 'accounts', data.id), {
    ...data,
  });
  return data;
};

const edit = async (id, data) => {
  await updateDoc(doc(db, 'accounts', id), {
    ...data,
  });
};

const funcs = {
  getAll,
  get,
  add,
  edit,
  remove,
};

export default funcs;
